import './AIKnowledgeBasePage.css';
import React, { useEffect, useState } from 'react';
import { useLoader } from 'src/provider/LoaderProvider';
import PageContentWrapper from 'src/components/PageContentWrapper/PageContentWrapper';
import CardContainer from 'src/components/CardContainer/CardContainer';
import { useMediaQuery } from 'src/hooks/useMediaQuery';
import { clsx } from 'clsx';
import { SearchFilesContainer } from 'src/components/SearchFilesContainer/SearchFilesContainer';
import { KnowledgeBaseTableList } from 'src/pages/AIKnowledgeBasePage/KnowledgeBaseTableList';
import { useGetKnowledgeBaseQuery } from 'src/services/knowledgeBaseService';
import { CreateEditAiKnowledgeBaseModal } from 'src/pages/AIKnowledgeBasePage/CreateEditAiKnowledgeBase/CreateEditAiKnowledgeBaseModal';
import { useDebounce } from 'src/hooks/useDebounce';
import { useAppSelector } from 'src/store';
import { Separator } from 'src/components/ui/separator';

const AIKnowledgeBasePage = () => {
  const loader = useLoader();
  const isLgDown = useMediaQuery('(max-width: 992px)');
  const [page, setPage] = useState(1);
  const [knowledgeBases, setKnowledgeBases] = useState([]);
  const [filteredValue, setFilteredValue] = useState('');

  const searchNameDebounce = useDebounce(filteredValue, 500);

  const {
    data: knowledgeBaseData,
    isError: isErrorKnowledgeBaseData,
    isLoading: isLoadingKnowledgeBaseData,
    isFetching: isFetchingKnowledgeBaseData,
  } = useGetKnowledgeBaseQuery(
    {
      load_projects: true,
      name_filter: searchNameDebounce,
      page: page,
      page_size: 20,
    },
    { refetchOnMountOrArgChange: true },
  ) as any;

  useEffect(() => {
    if (isLoadingKnowledgeBaseData) {
      loader.show();
    } else {
      loader.hide();
    }
  }, [isLoadingKnowledgeBaseData]);

  useEffect(() => {
    if (knowledgeBaseData) {
      const items = knowledgeBaseData.items || [];

      setKnowledgeBases(page === 1 ? [...items] : [...knowledgeBases, ...items]);
    }
  }, [knowledgeBaseData]);

  useEffect(() => {
    setPage(1);
  }, [searchNameDebounce]);

  const fetchOnScroll = () => {
    setPage(page + 1);
  };

  const onHandleSearch = (value) => {
    setFilteredValue(value);
  };
  const { isInactivePlan } = useAppSelector((s) => s.planSlice);

  return (
    <React.Fragment>
      <PageContentWrapper
        className={clsx('h-full', !isLgDown && 'relative')}
        isMobileMarginTop={false}
        isProjectBreadcrumbs={true}
        projectBreadcrumbsContent={'Knowledge Base'}
      >
        <div className="z-10 gap-[10px] flex flex-col relative h-[calc(100vh-130px)] overflow-hidden">
          <CardContainer className="h-full max-h-full">
            <div className="flex w-full justify-end gap-2.5">
              <SearchFilesContainer onSearch={onHandleSearch} hideSort hideViewType />
              <CreateEditAiKnowledgeBaseModal disabled={isInactivePlan} />
            </div>
            <Separator className={'mt-2 bg-light'} />
            <div
              className={clsx(
                'h-full max-h-full overflow-auto pr-2.5',
                (isLoadingKnowledgeBaseData || isFetchingKnowledgeBaseData) &&
                  'animate-pulse blur-sm pointer-events-none',
              )}
            >
              <KnowledgeBaseTableList
                isLoadingKnowledgeBaseData={isLoadingKnowledgeBaseData}
                knowledgeBaseData={knowledgeBases}
                filteredValue={filteredValue}
                fetchOnScroll={fetchOnScroll}
                isError={isErrorKnowledgeBaseData}
                hasNextPage={knowledgeBaseData?.page_info?.has_next_page}
              />
            </div>
          </CardContainer>
        </div>
      </PageContentWrapper>
    </React.Fragment>
  );
};

export default AIKnowledgeBasePage;
